<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid">
        <div class="p-col-12">
          <h1 style="margin-bottom: 0">
            Termo de uso e Política de privacidade Web Farm
          </h1>
          <UseTermText :termsAcceptedAt="user.termsAcceptedAt"></UseTermText>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import UseTermText from './components/UseTermText';

export default {
  name: 'UseTerm',
  components: {
    UseTermText,
  },
  computed: {
    ...mapFields('app', ['user']),
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0 !important;
}
</style>